import React, { useContext, useState } from "react";
import SearchBar from "../SearchBar/SearchBar";
const DropdownModal = dynamic(() => import("../DropdownModal/DropdownModal"), {
  ssr: false,
});
import { CommonFormContext } from "../MainComponent/MainComponent";
import getData from "@/commonJS/getData";
import dynamic from "next/dynamic";
// TODO - field type is any due to conflict in propety (need to update when free time)
const SerachableSelect = ({
  field,
  globalState,
  fullGlobalState,
  inputValue,
  path,
  showErrors,
  inputError,
  onChange,
  onKeyDown
}: {
  field: any;
  globalState?: any;
  fullGlobalState: any;
  inputValue:string;
  path: string[];
  showErrors:any;
  inputError:any;
  onChange:Function;
  onKeyDown:Function;
}) => {
  const context = useContext(CommonFormContext);
  const [showDropdownModal, setShowDropdownModal] = useState(true);
  return (
    <div style={{ position: "relative",...field?.mainStyle }}>
      <SearchBar
        field={field}
        inputValue={inputValue}
        onFocus={(e: any) => {
          setShowDropdownModal(true);
          context.handleOnFocus(
            e,
            field?.properties?.onFocus?.actions,
            globalState
          );
        }}
        onBlur={() => {
          setTimeout(() => setShowDropdownModal(false), 300);
        }}
        showErrors={showErrors}
        inputError={inputError}
        onChange={onChange}
        onKeyDown={onKeyDown}
      />

      {showDropdownModal &&
        getData(
          field?.structure?.dataFrom,
          globalState,
          globalState,
          fullGlobalState
        ) && (
          <DropdownModal
            path={path}
            field={field}
            globalState={globalState}
            fullGlobalState={fullGlobalState ?? globalState}
          />
        )}
    </div>
  )
}

export default SerachableSelect;
